<h2>Импорт товаров</h2>
<form class="drop-padding" (ngSubmit)="upload()" [formGroup]="formGroup">
  <input #file_input class="file_input" type="file" (change)="onFileSelected($event)" />
  <mat-form-field appearance="outline">
    <mat-label>Колонка названия</mat-label>
    <input
      matInput
      type="text"
      placeholder="Колонка названия"
      formControlName="description_column"
    />
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Колонка артикула</mat-label>
    <input matInput type="text" placeholder="Колонка артикула" formControlName="article_column" />
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Колонка производителя</mat-label>
    <input
      matInput
      type="text"
      placeholder="Колонка производителя"
      formControlName="brand_column"
    />
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Колонка папки</mat-label>
    <input matInput type="text" placeholder="Колонка папки" formControlName="folder_column" />
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Колонка изображения</mat-label>
    <input matInput type="text" placeholder="Колонка изображения" formControlName="image_column" />
  </mat-form-field>
  <button
    mat-flat-button
    color="primary"
    type="button"
    (click)="file_input.click()"
    [disabled]="loading"
  >
    {{ selectedFile ? selectedFile.name : 'Выбарть файл' }}
  </button>
  <button mat-flat-button color="primary" type="submit" [disabled]="loading">
    {{ loading ? 'Загрузка' : 'Загрузить' }}
  </button>
</form>
